import values from 'object.values'
import 'string.prototype.startswith'

if (!Object.values) {
    values.shim();
}



// WEBPACK FOOTER //
// ./src/polyfills.js